export default __webpack_public_path__ + "static/media/React_Mortgage_Calculator_from_Town_Country_Federal_Credit_Union.2894b90f.png";